import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';

const state = {
    clientes: [],
    /* Opciones de filtro y paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,

    nombre: '',
    // cuit: '',
    documentoNumero: '',
    incluirInactivos: false,

    rptClientes: [],

    /* Listas de seleccion */
    list: [],
    selectList: []
};

const mutations = {
    updateField,

    'INICIALIZAR_OPCIONES'(state) {
        state.clientes = [];
        /* Opciones de filtro y paginacion */
        state.paginaActual = 1;
        state.registrosPorPagina = 10;
        state.totalRegistros = 0;
        state.totalPaginas = 0;

        state.nombre = '';
        state.documentoNumero = '';
        state.incluirInactivos = false;
    },

    'INICIALIZAR_CLIENTES'(state) {
        state.clientes = [];
    },
    'CLIENTES'(state, clientes) {
        state.clientes = clientes;
    },
    'CLIENTES_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },

    'INICIALIZAR_LIST'(state) {
        state.list = [];
        state.selectList = [];
    },
    'SET_LIST'(state, list) {
        state.list = list;
        state.selectList = list.map(item => item.nombre.trim());
    },
    'INICIALIZAR_RPT'(state) {
        state.rptClientes = [];
    },
    'SET_RPT'(state, rptClientes) {
        state.rptClientes = rptClientes;
    },    
};

const actions = {
    inicializarOpciones ( { commit } ) {
        commit('INICIALIZAR_OPCIONES');
    },
    getClientes: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_CLIENTES')

            let queryString = '';
            
            queryString += '?pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual

            if (state.nombre != '') {
                queryString += '&nombre=' + state.nombre;
            }
            if (state.documentoNumero != '') {
                queryString += '&documentoNumero=' + state.documentoNumero;
            }
            // if (state.cuit != '') {
            //     queryString += '&cuit=' + state.cuit;
            // }
            if ((/true/i).test(state.incluirInactivos)) {
                queryString += '&incluirInactivos= true';
            }

            apiAxios.get('clientes' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('CLIENTES_PAGINATION', params);
                    }
                    commit('CLIENTES', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getRptClientes: ({commit}) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RPT')

            let queryString = '';
            
            if (state.nombre != '') {
                queryString += (queryString == ''? '?' : '&') + 'nombre=' + state.nombre;
            }
            if (state.documentoNumero != '') {
                queryString += (queryString == ''? '?' : '&') + 'documentoNumero=' + state.documentoNumero;
            }
            // if (state.cuit != '') {
            //     queryString += '&cuit=' + state.cuit;
            // }
            if ((/true/i).test(state.incluirInactivos)) {
                queryString += (queryString == ''? '?' : '&') + 'incluirInactivos= true';
            }

            apiAxios.get('clientes/rpt' + queryString)
                .then(res => {
                    commit('SET_RPT', res.data)

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
    getList: ( { commit }, params) => {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_LIST')
            
            let queryString = '';

            if (params) {
                if ((/true/i).test(params.incluirInactivos)) {
                    queryString = '?incluirInactivos= true';
                }
            }

            apiAxios.get('clientes/list' + queryString)
                .then(res => {
                    commit('SET_LIST', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },
};

const getters = {
    getField,

    clientes (state) {
        return state.clientes;
    },
    list (state) {
        return state.list;
    },
    selectList (state) {
        return state.selectList;
    },
    rptClientes (state) {
        return state.rptClientes;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}